import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import TwitterText from 'twitter-text';
import * as _ from "../../../util/lodash";
import { whitelistStyles } from "../../core/hoc";
import validators from "../../../validators";
var HighlightTweet = createComponent({
  displayName: 'HighlightTweet',
  propTypes: {
    children: PropTypes.string.isRequired,
    displayedUrls: PropTypes.arrayOf(PropTypes.shape({
      displayedUrl: PropTypes.string,
      linkUrl: PropTypes.string
    }))
  },
  defaultProps: {
    displayedUrls: []
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(p) {
    var _cx = cx({
      ck: true,
      'highlight-tweet': true,
      'highlight-tweet--inverted': p.isInverted
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _cx,
      style: p.style
    }, linkTweet(p.children, p.displayedUrls));
  }
});

var linkTweet = function linkTweet(text, displayedUrls) {
  // Array of urls, hashtags and mentions with their indices
  // Ex. [{ hashtag: "koala", indices: [0,6] }, { url: fb.me/2aabe, indices: [27,42], { screenName: Etsy, indices: [47,52] }]
  var entities = TwitterText.extractEntitiesWithIndices(text); // If there are no entities, display the text as is

  if (entities.length === 0) return text; // Create a map of the displayedUrls passed in. Ex. output { 'google.com': https://t.co/qiza }

  var urlMap = createUrlMap(displayedUrls);

  var entitiesToLink = _filterInstanceProperty(_).call(_, entities, function (entity) {
    return !!entity.hashtag || !!entity.screenName || !!entity.url;
  });

  var temp = '',
      endOfLastEntity = 0,
      components = []; // For each of the entities, we will slice the text before it and create a span element pushing it to our component array.
  // Then, we'll create an anchor element for the entity and push it to the components array.

  _.each(entitiesToLink, function (entity, idx) {
    var type = entity.screenName && 'screenName' || entity.hashtag && 'hashtag' || entity.url && 'url';
    var value = entity[type]; // A mention, hashtag or url

    temp += _sliceInstanceProperty(text).call(text, endOfLastEntity, entity.indices[0]);
    components.push( /*#__PURE__*/React.createElement("span", {
      key: "" + temp + idx
    }, temp));
    components.push(anchorMethods[type](value, idx, urlMap[value]));
    endOfLastEntity = entity.indices[1];
    temp = '';
  }); // Take any remaining text and push it to our components array


  components.push( /*#__PURE__*/React.createElement("span", {
    key: text
  }, _sliceInstanceProperty(text).call(text, endOfLastEntity)));
  return components;
}; // Support methods for linkTweet


var anchorMethods = {
  hashtag: function hashtag(_hashtag, idx) {
    return /*#__PURE__*/React.createElement("a", {
      className: "highlight-tweet__hashtag",
      href: "http://twitter.com/hashtag/" + _hashtag + "?src=hash",
      target: "_blank",
      key: "" + _hashtag + idx,
      rel: "noopener noreferrer"
    }, "#" + _hashtag);
  },
  screenName: function screenName(_screenName, idx) {
    return /*#__PURE__*/React.createElement("a", {
      className: "highlight-tweet__mention",
      href: "http://twitter.com/" + _screenName,
      target: "_blank",
      key: "" + _screenName + idx,
      rel: "noopener noreferrer"
    }, "@" + _screenName);
  },
  url: function url(_url, idx, linkUrl) {
    // Makes the url protocol relative if there is not supplied linkUrl and it isn't a valid url
    if (validators.isURL()(_url) !== true && !linkUrl) {
      linkUrl = "//" + _url;
    } // There is some content that was consumed by us that still has the protocol on the URL.
    // This is to clear it in those instances.


    if (validators.isURL()(_url) === true) {
      if (!linkUrl) {
        linkUrl = _url;
      }

      _url = _url.replace(/^(https?:\/\/)/, '');
      _url = _url.replace(/^(www\.)/, '');
    }

    return /*#__PURE__*/React.createElement("a", {
      className: "highlight-tweet__link",
      href: "" + linkUrl,
      target: "_blank",
      key: "" + _url + idx,
      rel: "noopener noreferrer"
    }, _url);
  }
};

var createUrlMap = function createUrlMap(displayedUrls) {
  return _reduceInstanceProperty(_).call(_, displayedUrls, function (map, url) {
    var ellipsisFreeUrl = url.displayedUrl.replace(/\u2026$|\.{3}$/, '');
    map[ellipsisFreeUrl] = url.linkUrl;
    return map;
  }, {});
};

export default whitelistStyles()(HighlightTweet);
//# sourceMappingURL=index.js.map